import React from "react";
import { ModalBody } from "./styles";
import Modal from "react-modal";
import { BoldLg, SpaceBetween } from "../CustomStyles";
import CloseIcon from "@mui/icons-material/Close";
import CustomText from "../Text";
import Colors from "../../Constant/Colors";
import ClipLoader from "react-spinners/ClipLoader";

const ModalComponent = ({
  openModal,
  closeModal,
  children,
  heading,
  yesBtn,
  noBtn,
  yesBtnTxt,
  noBtnTxt,
  disabledYesBtn,
  loading,
  styles
}) => {
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      minWidth: 300,
      borderRadius: 20,
      padding: 20,
      maxWidth: '90%',
      maxHeight: '90%',
      ...styles
    },
    modalBtn2: {
      borderRadius: 50,
      borderWidth: 2,
      borderColor: Colors.primary,
      padding: '0 10px',
      width: "48%",
      display: 'flex',
      alignItems: "center",
      justifyContent: "center",
      cursor: 'pointer',
      boxShadow: '1px 2px 3px 1px #6666',
      height: 30,
      marginRight: '4%', // Add margin to create gap
    },
    modalBtn3: (noBtn, disabled) => ({
      borderRadius: 50,
      backgroundColor: disabled ? Colors.disabled : Colors.primary,
      padding: '0 10px',
      width: noBtn ? "48%" : "100%",
      display: 'flex',
      alignItems: "center",
      justifyContent: "center",
      cursor: 'pointer',
      boxShadow: '1px 2px 3px 1px #6666',
      height: 30,
      marginRight: noBtn ? '0' : '4%', // Add margin to create gap if there is no 'noBtn'
    }),
    btnView: {
      display: 'flex',
      flexDirection: "row",
      justifyContent: "space-between",
      height: 35,
      marginTop: 10,
      width: "100%",
    },
    btnTxt: {
      color: Colors.primary,
      textAlign: "center",
      fontWeight: '700',
    },
    btnTxt2: {
      color: Colors.whiteThemeColor,
      textAlign: "center",
      fontWeight: '700',
    },
  };

  return (
    <Modal isOpen={openModal} onRequestClose={closeModal} style={customStyles}>
      <SpaceBetween>
        <BoldLg>{heading ?? "Upload"}</BoldLg>
        <span onClick={closeModal} style={{ cursor: "pointer" }}>
          <CloseIcon />
        </span>
      </SpaceBetween>
      <ModalBody>{children}</ModalBody>
      {(yesBtn || noBtn) && (
        <div style={customStyles.btnView}>
          {noBtn && (
            <div onClick={noBtn} style={customStyles.modalBtn2}>
              <CustomText
                style={customStyles.btnTxt}
                text={noBtnTxt ?? "Cancel"}
              />
            </div>
          )}
          <div
            onClick={disabledYesBtn ? null : yesBtn}
            style={customStyles.modalBtn3(noBtn, disabledYesBtn)}
          >{loading ?
            <ClipLoader color={Colors.whiteThemeColor} size={20} />
            :
            <CustomText
              style={customStyles.btnTxt2}
              text={yesBtnTxt ?? "Confirm"}
            />
            }
          </div>
        </div>
      )}
    </Modal>
  );
};

export default ModalComponent;
